import {List} from 'immutable';
import Scorecard from 'records/Scorecard';
import {callsApi} from 'sources/api';

const questionAdapter = kotlinQuestion => ({
  id: kotlinQuestion.questionId,
  text: kotlinQuestion.questionText,
  allowComments: kotlinQuestion.allowComments,
  cardReasonSchemeId: kotlinQuestion.cardReasonSchemeId,
  skillIds: kotlinQuestion.skillIds,
  scorecardId: kotlinQuestion.scorecardId,
});

export default {
  fetchScorecardsForDepartment(departmentId, params) {
    return callsApi
      .getJson(`/scorecards`, {
        params: {
          department_id: departmentId,
          ...params,
        },
      })
      .then(scorecards =>
        List(
          scorecards.map(
            scorecard =>
              new Scorecard({
                ...scorecard,
                questions: scorecard.questions.map(questionAdapter),
              })
          )
        )
      );
  },

  fetchScorecardQuestionById(qid) {
    return callsApi
      .getJson(`/scorecards/questions/${qid}`)
      .then(question => questionAdapter(question));
  },

  fetch(id) {
    return callsApi.getJson(`/scorecards/${id}/metadata`).then(
      scorecard =>
        new Scorecard({
          ...scorecard,
          questions: scorecard.questions.map(questionAdapter),
        })
    );
  },
};
